import { render } from "./AskDoubtassTeacher.vue?vue&type=template&id=3a8bf46b&scoped=true"
import script from "./AskDoubtassTeacher.vue?vue&type=script&lang=js"
export * from "./AskDoubtassTeacher.vue?vue&type=script&lang=js"

import "./AskDoubtassTeacher.vue?vue&type=style&index=0&id=3a8bf46b&scoped=true&lang=scss"

import exportComponent from "C:\\prathamesh\\mahajyoti_admin_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a8bf46b"]])

export default __exports__